/**
 * External Dependencies
 */
import 'jquery';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';

SwiperCore.use([Pagination]);

$(document).ready(() => {
  /* Initialize logo Swiper on frontpage */
  const swiper = new SwiperCore('.swiper-container', {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 4,
    spaceBetween: 40,
    autoplay: {
      delay: 100,
      disableOnInteraction: false,
    },

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });

  const swiperFull = new SwiperCore('.swiper-container-full', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });

  swiper.init();
  swiperFull.init();

  /**
   * jQuery AJAX filter. Combines both forms on page.
   * Could probably be refactored into a single function 
   */
  jQuery(function ($) {
    var sidebarFilter = $('#filter');
    var homeFilter = $('#searchfilter');

    function doFilter() {
      $('#response').css('opacity', '0');
      $.ajax({
        url: sidebarFilter.attr('action'),
        data: sidebarFilter.serialize() + '&' + homeFilter.serialize(),
        type: sidebarFilter.attr('method'),
        success: function (data) {
          $('#response').html(data).css({ opacity: 0, transform: 'translateY(-100px)' });
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              $('#response').css({ opacity: 1, transform: 'translateY(0)' });
            });
          });
        },
      });
    }

    $('#filter').on('change', function () {
      sidebarFilter = $('#filter');
      doFilter();
    });

    $('#searchfilter').on('submit', function (e) {
      e.preventDefault();
      homeFilter = $('#searchfilter');
      doFilter();
    });
    return false;
  });

  /**
   * Mega menu slider only for vacature! activated by 
   * nav-mega-menu class in 
   */
  var megaMenuTimer = null;

  function closeMegaMenu() {
    $('.nav-mega-menu').slideUp('fast');
    $('.sub-menu').css('opacity', '');
    $('.backdrop-overlay').css('opacity', '0').addClass('pointer-events-none');
  }

  function scheduleMegaClose() {
    megaMenuTimer = setTimeout(closeMegaMenu, 300);
  }

  function cancelMegaClose() {
    clearTimeout(megaMenuTimer);
  }

  $('#menu-item-6').on('mouseenter', function () {
    if ($(window).width() < 1024) return;
    cancelMegaClose();
    $('.nav-mega-menu').slideDown('fast');
    $('.sub-menu').css('opacity', '0');
    $('.backdrop-overlay').css('opacity', '0.5').removeClass('pointer-events-none');
  }).on('mouseleave', function () {
    if ($(window).width() < 1024) return;
    scheduleMegaClose();
  });

  $('.nav-mega-menu').on('mouseenter', function () {
    if ($(window).width() < 1024) return;
    cancelMegaClose();
  }).on('mouseleave', function () {
    if ($(window).width() < 1024) return;
    scheduleMegaClose();
  });

  $('header.banner').on('mouseleave', function () {
    if ($(window).width() < 1024) return;
    cancelMegaClose();
    closeMegaMenu();
  });

  /**
   * Mobile menu
   */
  function closeMobileNav() {
    $('.hamburger').removeClass('is-active');
    $('.nav-primary').removeClass('mobile-active');
    $('body').removeClass('mobile-nav-active overflow-filter');
  }

  $('.hamburger').on('click', function () {
    var isOpen = $(this).hasClass('is-active');
    if (isOpen) {
      closeMobileNav();
    } else {
      $(this).addClass('is-active');
      $('.nav-primary').addClass('mobile-active');
      $('body').addClass('mobile-nav-active overflow-filter');
    }
  });

  // Close button inside the overlay
  $('.mobile-nav-close').on('click', function () {
    closeMobileNav();
  });

  // Inject sub-menu toggle chevrons next to each parent nav link
  $('.nav-primary .menu-item-has-children > a').after(
    '<button class="submenu-toggle" type="button" aria-expanded="false">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
    '<polyline points="6 9 12 15 18 9"/></svg></button>'
  );

  // Toggle sub-menu on chevron click
  $('.nav-primary').on('click', '.submenu-toggle', function (e) {
    e.stopPropagation();
    var $btn = $(this);
    var $submenu = $btn.closest('.menu-item-has-children').find('> .sub-menu');
    var isOpen = $btn.hasClass('is-open');

    $btn.toggleClass('is-open').attr('aria-expanded', !isOpen);
    $submenu.slideToggle(220);
  });

  // Close on nav link click (navigate + close overlay)
  $('.nav-primary').on('click', '#menu-primary a', function () {
    closeMobileNav();
  });

  // Close on Escape key
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') closeMobileNav();
  });

  function closeAsideFilter() {
    $('.aside-filter').removeClass('mobile-active');
    $('body').removeClass('overflow-filter');
  }

  $('#filter-button').on('click', function () {
    $('.aside-filter').toggleClass('mobile-active');
    $('body').toggleClass('overflow-filter');
  });

  $(document).on('click', '.sidebar-filter-close', function () {
    closeAsideFilter();
  });

  // Close on backdrop click (click outside the form)
  $('.aside-filter').on('click', function (e) {
    if ($(e.target).is('.aside-filter')) closeAsideFilter();
  });

  // Close on Escape
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') closeAsideFilter();
  });

  /**
   * Function to display vacature CTA on page bottom left
   * Refactor from:
   * https://bitbucket.org/booomdevelopment/adaptics/src/ec97018b0ce9007b194eaedffd85567e6a8828d5/resources/assets/scripts/routes/common.js?at=master
   * To be honest I don't really get it -OAP
   */
  const mq = window.matchMedia('(max-width: 1220px)');
  mq.addListener(WidthChange);
  WidthChange(mq);

  function WidthChange(mq) {
    if (mq.matches) {
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (!document.body.classList.contains('mobile-nav-active')) {
          if (prevScrollpos > currentScrollPos) {
            //  document.getElementsByClassName('c__main-nav')[0].style.top = '0';
          } else {
            //  document.getElementsByClassName('c__main-nav')[0].style.top = '-125px';
          }
          prevScrollpos = currentScrollPos;
        }
      };
    } else {
      // do nothing
    }
  }

  const headerVacature = document.getElementById('header-vacature');
  const ctaSoliciteer = document.getElementById('cta-soliciteer');

  if (headerVacature && ctaSoliciteer) {
    new IntersectionObserver(function (entries) {
      ctaSoliciteer.classList.toggle('hidden', entries[0].isIntersecting);
    }).observe(headerVacature);
  }

  /**
   * Language switcher toggle
   */

  // Resolve lazy-loaded flag images and populate the toggle button
  function initLangSwitcher() {
    // Fix lazy src on all option flags
    $('.gt_option img[data-gt-lazy-src]').each(function () {
      if (!$(this).attr('src')) {
        $(this).attr('src', $(this).attr('data-gt-lazy-src'));
      }
    });

    // Populate toggle with current language from .gt_selected (has real src already)
    var $selected = $('.gt_selected a');
    if ($selected.length) {
      var flagSrc = $selected.find('img').attr('src');
      var label = $selected.text().trim();
      setLangToggle(flagSrc, label);
    }
  }

  function setLangToggle(flagSrc, label) {
    $('.lang-current').html(
      '<img src="' + flagSrc + '" width="20" height="20" style="border-radius:2px;flex-shrink:0"> ' +
      '<span>' + label + '</span>'
    );
  }

  // GTranslate may render after DOM ready — wait briefly if needed
  if ($('.gt_selected a').length) {
    initLangSwitcher();
  } else {
    setTimeout(initLangSwitcher, 400);
  }

  $('.lang-switcher-toggle').on('click', function (e) {
    e.stopPropagation();
    var $toggle = $(this);
    var $dropdown = $toggle.closest('.lang-switcher').find('.lang-switcher-dropdown');
    var isOpen = $toggle.hasClass('is-open');

    $toggle.toggleClass('is-open').attr('aria-expanded', !isOpen);
    $dropdown.slideToggle(150);
  });

  // Update toggle label after a language is chosen
  $(document).on('click', '.gt_option a', function () {
    var flagSrc = $(this).find('img').attr('src') || $(this).find('img').attr('data-gt-lazy-src');
    var label = $(this).text().trim();
    setLangToggle(flagSrc, label);
    $('.lang-switcher-toggle').removeClass('is-open').attr('aria-expanded', false);
    $('.lang-switcher-dropdown').slideUp(150);
  });

  // Prevent GTranslate's own .gt_selected toggle from firing
  $(document).on('click', '.gt_selected a', function (e) {
    e.stopPropagation();
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.lang-switcher').length) {
      $('.lang-switcher-toggle.is-open').removeClass('is-open').attr('aria-expanded', false);
      $('.lang-switcher-dropdown').slideUp(150);
    }
  });

  /**
   * File upload: show selected filename below the drop zone
   */
  $(document).on('change', '.ginput_container_fileupload input[type="file"]', function () {
    var $input = $(this);
    var $container = $input.closest('.ginput_container_fileupload');
    var file = this.files && this.files[0];
    $container.find('.file-upload-name').remove();
    if (file) {
      $container.append(
        '<span class="file-upload-name">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24" style="display:inline;vertical-align:middle;margin-right:6px"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>' +
        file.name +
        '</span>'
      );
    }
  });

  /**
   * Modal Popup trigger sollicitatie
   */
  const modal = document.getElementById('lidWordenModal');
  const modalBackdrop = document.getElementById('modalBackdrop');
  const closeBtn = document.getElementById('closeLidModal');
  let lastFocusedElement = null;

  const FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function openModal(trigger) {
    lastFocusedElement = trigger || document.activeElement;
    modal.removeAttribute('aria-hidden');
    $(modal).fadeIn(200, function () {
      const first = modal.querySelector(FOCUSABLE);
      if (first) first.focus();
    });
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    $(modal).fadeOut(200, function () {
      if (lastFocusedElement) lastFocusedElement.focus();
    });
  }

  $(document).on('click', '#btn-solliciteer-1, #btn-solliciteer-2, #btn-solliciteer-3', function () {
    openModal(this);
  });

  const modalContent = document.getElementById('modalContent');

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal);
  if (modalContent) modalContent.addEventListener('click', function (e) { e.stopPropagation(); });

  document.addEventListener('keydown', function (e) {
    if (!modal || modal.getAttribute('aria-hidden') === 'true') return;

    if (e.key === 'Escape') {
      closeModal();
      return;
    }

    if (e.key === 'Tab') {
      const focusable = Array.from(modal.querySelectorAll(FOCUSABLE));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
});
